export default "__VITE_ASSET__BOec$fN4__"